import _slicedToArray from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty2 from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { C as Connector, _ as _defineProperty, a as _classPrivateFieldInitSpec, n as normalizeChainId, b as ConnectorNotFoundError, U as UserRejectedRequestError, c as _classPrivateFieldSet, d as _classPrivateFieldGet, e as allChains, f as ChainNotConfiguredError, A as AddChainError, S as SwitchChainError, g as defaultChains, h as defaultL2Chains } from './base-2a0d02bb.esm.js';
export { A as AddChainError, f as ChainNotConfiguredError, C as Connector, k as ConnectorAlreadyConnectedError, b as ConnectorNotFoundError, S as SwitchChainError, U as UserRejectedRequestError, e as allChains, i as chain, g as defaultChains, h as defaultL2Chains, j as developmentChains, n as normalizeChainId } from './base-2a0d02bb.esm.js';
import { Web3Provider } from '@ethersproject/providers';
import { getAddress, hexValue } from 'ethers/lib/utils';
import { ethers, utils } from 'ethers';
import 'eventemitter3';
var erc1155ABI = [{
  constant: true,
  inputs: [{
    internalType: 'address',
    name: '_owner',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: '_id',
    type: 'uint256'
  }],
  name: 'balanceOf',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: true,
  inputs: [{
    internalType: 'uint256',
    name: '_id',
    type: 'uint256'
  }],
  name: 'uri',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}];
var erc20ABI = [{
  constant: true,
  inputs: [],
  name: 'name',
  outputs: [{
    name: '',
    type: 'string'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: false,
  inputs: [{
    name: '_spender',
    type: 'address'
  }, {
    name: '_value',
    type: 'uint256'
  }],
  name: 'approve',
  outputs: [{
    name: '',
    type: 'bool'
  }],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: true,
  inputs: [],
  name: 'totalSupply',
  outputs: [{
    name: '',
    type: 'uint256'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: false,
  inputs: [{
    name: '_from',
    type: 'address'
  }, {
    name: '_to',
    type: 'address'
  }, {
    name: '_value',
    type: 'uint256'
  }],
  name: 'transferFrom',
  outputs: [{
    name: '',
    type: 'bool'
  }],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: true,
  inputs: [],
  name: 'decimals',
  outputs: [{
    name: '',
    type: 'uint8'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: true,
  inputs: [{
    name: '_owner',
    type: 'address'
  }],
  name: 'balanceOf',
  outputs: [{
    name: 'balance',
    type: 'uint256'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: true,
  inputs: [],
  name: 'symbol',
  outputs: [{
    name: '',
    type: 'string'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: false,
  inputs: [{
    name: '_to',
    type: 'address'
  }, {
    name: '_value',
    type: 'uint256'
  }],
  name: 'transfer',
  outputs: [{
    name: '',
    type: 'bool'
  }],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: true,
  inputs: [{
    name: '_owner',
    type: 'address'
  }, {
    name: '_spender',
    type: 'address'
  }],
  name: 'allowance',
  outputs: [{
    name: '',
    type: 'uint256'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  payable: true,
  stateMutability: 'payable',
  type: 'fallback'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: 'owner',
    type: 'address'
  }, {
    indexed: true,
    name: 'spender',
    type: 'address'
  }, {
    indexed: false,
    name: 'value',
    type: 'uint256'
  }],
  name: 'Approval',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: 'from',
    type: 'address'
  }, {
    indexed: true,
    name: 'to',
    type: 'address'
  }, {
    indexed: false,
    name: 'value',
    type: 'uint256'
  }],
  name: 'Transfer',
  type: 'event'
}];
var erc721ABI = [{
  inputs: [{
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'ownerOf',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'tokenURI',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}]; // https://github.com/ethers-io/ethers.js/blob/master/packages/units/src.ts/index.ts#L10-L18

var units = ['wei', 'kwei', 'mwei', 'gwei', 'szabo', 'finney', 'ether'];

var getInjectedName = function getInjectedName(ethereum) {
  if (!ethereum) return 'Injected';
  if (ethereum.isBraveWallet) return 'Brave Wallet';
  if (ethereum.isMetaMask) return 'MetaMask';
  if (ethereum.isCoinbaseWallet) return 'Coinbase Wallet';
  if (ethereum.isFrame) return 'Frame';
  if (ethereum.isTally) return 'Tally';
  return 'Injected';
};

var shimKey = 'wagmi.shimDisconnect';

var _provider = /*#__PURE__*/new WeakMap();

var InjectedConnector = /*#__PURE__*/function (_Connector) {
  _inherits(InjectedConnector, _Connector);

  var _super = _createSuper(InjectedConnector);

  function InjectedConnector(config) {
    var _this;

    _classCallCheck(this, InjectedConnector);

    _this = _super.call(this, _objectSpread(_objectSpread({}, config), {}, {
      options: config === null || config === void 0 ? void 0 : config.options
    }));

    _defineProperty(_assertThisInitialized(_this), "id", 'injected');

    _defineProperty(_assertThisInitialized(_this), "name", void 0);

    _defineProperty(_assertThisInitialized(_this), "ready", typeof window != 'undefined' && !!window.ethereum);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _provider, {
      writable: true,
      value: void 0
    });

    _defineProperty(_assertThisInitialized(_this), "onAccountsChanged", function (accounts) {
      if (accounts.length === 0) _this.emit('disconnect');else _this.emit('change', {
        account: getAddress(accounts[0])
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChainChanged", function (chainId) {
      var id = normalizeChainId(chainId);

      var unsupported = _this.isChainUnsupported(id);

      _this.emit('change', {
        chain: {
          id: id,
          unsupported: unsupported
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDisconnect", function () {
      var _this$options;

      _this.emit('disconnect');

      if ((_this$options = _this.options) !== null && _this$options !== void 0 && _this$options.shimDisconnect) typeof localStorage !== 'undefined' && localStorage.removeItem(shimKey);
    });

    var name = 'Injected';
    if (typeof window !== 'undefined') name = getInjectedName(window.ethereum);
    _this.name = name;
    return _this;
  }

  _createClass(InjectedConnector, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$options3, provider, _this$options2, account, id, unsupported;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                provider = this.getProvider();

                if (provider) {
                  _context.next = 4;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 4:
                if (provider.on) {
                  provider.on('accountsChanged', this.onAccountsChanged);
                  provider.on('chainChanged', this.onChainChanged);
                  if (!((_this$options2 = this.options) !== null && _this$options2 !== void 0 && _this$options2.shimChainChangedDisconnect)) provider.on('disconnect', this.onDisconnect);
                }

                _context.next = 7;
                return this.getAccount();

              case 7:
                account = _context.sent;
                _context.next = 10;
                return this.getChainId();

              case 10:
                id = _context.sent;
                unsupported = this.isChainUnsupported(id);
                if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.shimDisconnect) typeof localStorage !== 'undefined' && localStorage.setItem(shimKey, 'true');
                return _context.abrupt("return", {
                  account: account,
                  chain: {
                    id: id,
                    unsupported: unsupported
                  },
                  provider: provider
                });

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);

                if (!(_context.t0.code === 4001)) {
                  _context.next = 20;
                  break;
                }

                throw new UserRejectedRequestError();

              case 20:
                throw _context.t0;

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 16]]);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$options4, provider;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                provider = this.getProvider();

                if (provider !== null && provider !== void 0 && provider.removeListener) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                provider.removeListener('accountsChanged', this.onAccountsChanged);
                provider.removeListener('chainChanged', this.onChainChanged);
                provider.removeListener('disconnect', this.onDisconnect);
                if ((_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.shimDisconnect) typeof localStorage !== 'undefined' && localStorage.removeItem(shimKey);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "getAccount",
    value: function () {
      var _getAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var provider, accounts;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                provider = this.getProvider();

                if (provider) {
                  _context3.next = 3;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 3:
                _context3.next = 5;
                return provider.request({
                  method: 'eth_requestAccounts'
                });

              case 5:
                accounts = _context3.sent;
                return _context3.abrupt("return", getAddress(accounts[0]));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAccount() {
        return _getAccount.apply(this, arguments);
      }

      return getAccount;
    }()
  }, {
    key: "getChainId",
    value: function () {
      var _getChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var provider;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                provider = this.getProvider();

                if (provider) {
                  _context4.next = 3;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 3:
                _context4.next = 5;
                return provider.request({
                  method: 'eth_chainId'
                }).then(normalizeChainId);

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getChainId() {
        return _getChainId.apply(this, arguments);
      }

      return getChainId;
    }()
  }, {
    key: "getProvider",
    value: function getProvider() {
      if (typeof window !== 'undefined' && !!window.ethereum) _classPrivateFieldSet(this, _provider, window.ethereum);
      return _classPrivateFieldGet(this, _provider);
    }
  }, {
    key: "getSigner",
    value: function () {
      var _getSigner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var provider, account;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                provider = this.getProvider();
                _context5.next = 3;
                return this.getAccount();

              case 3:
                account = _context5.sent;
                return _context5.abrupt("return", new Web3Provider(provider).getSigner(account));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getSigner() {
        return _getSigner.apply(this, arguments);
      }

      return getSigner;
    }()
  }, {
    key: "isAuthorized",
    value: function () {
      var _isAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this$options5, provider, accounts, account;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (!((_this$options5 = this.options) !== null && _this$options5 !== void 0 && _this$options5.shimDisconnect && typeof localStorage !== 'undefined' && !localStorage.getItem(shimKey))) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", false);

              case 3:
                provider = this.getProvider();

                if (provider) {
                  _context6.next = 6;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 6:
                _context6.next = 8;
                return provider.request({
                  method: 'eth_accounts'
                });

              case 8:
                accounts = _context6.sent;
                account = accounts[0];
                return _context6.abrupt("return", !!account);

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", false);

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 13]]);
      }));

      function isAuthorized() {
        return _isAuthorized.apply(this, arguments);
      }

      return isAuthorized;
    }()
  }, {
    key: "switchChain",
    value: function () {
      var _switchChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(chainId) {
        var provider, id, chains, _chain$blockExplorers, chain;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                provider = this.getProvider();

                if (provider) {
                  _context7.next = 3;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 3:
                id = hexValue(chainId);
                _context7.prev = 4;
                _context7.next = 7;
                return provider.request({
                  method: 'wallet_switchEthereumChain',
                  params: [{
                    chainId: id
                  }]
                });

              case 7:
                chains = [].concat(_toConsumableArray(this.chains), _toConsumableArray(allChains));
                return _context7.abrupt("return", chains.find(function (x) {
                  return x.id === chainId;
                }));

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](4);

                if (!(_context7.t0.code === 4902)) {
                  _context7.next = 28;
                  break;
                }

                _context7.prev = 14;
                chain = this.chains.find(function (x) {
                  return x.id === chainId;
                });

                if (chain) {
                  _context7.next = 18;
                  break;
                }

                throw new ChainNotConfiguredError();

              case 18:
                _context7.next = 20;
                return provider.request({
                  method: 'wallet_addEthereumChain',
                  params: [{
                    chainId: id,
                    chainName: chain.name,
                    nativeCurrency: chain.nativeCurrency,
                    rpcUrls: chain.rpcUrls,
                    blockExplorerUrls: (_chain$blockExplorers = chain.blockExplorers) === null || _chain$blockExplorers === void 0 ? void 0 : _chain$blockExplorers.map(function (x) {
                      return x.url;
                    })
                  }]
                });

              case 20:
                return _context7.abrupt("return", chain);

              case 23:
                _context7.prev = 23;
                _context7.t1 = _context7["catch"](14);
                throw new AddChainError();

              case 26:
                _context7.next = 33;
                break;

              case 28:
                if (!(_context7.t0.code === 4001)) {
                  _context7.next = 32;
                  break;
                }

                throw new UserRejectedRequestError();

              case 32:
                throw new SwitchChainError();

              case 33:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 11], [14, 23]]);
      }));

      function switchChain(_x) {
        return _switchChain.apply(this, arguments);
      }

      return switchChain;
    }()
  }, {
    key: "watchAsset",
    value: function () {
      var _watchAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref) {
        var address, _ref$decimals, decimals, image, symbol, provider;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                address = _ref.address, _ref$decimals = _ref.decimals, decimals = _ref$decimals === void 0 ? 18 : _ref$decimals, image = _ref.image, symbol = _ref.symbol;
                provider = this.getProvider();

                if (provider) {
                  _context8.next = 4;
                  break;
                }

                throw new ConnectorNotFoundError();

              case 4:
                _context8.next = 6;
                return provider.request({
                  method: 'wallet_watchAsset',
                  params: {
                    type: 'ERC20',
                    options: {
                      address: address,
                      decimals: decimals,
                      image: image,
                      symbol: symbol
                    }
                  }
                });

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function watchAsset(_x2) {
        return _watchAsset.apply(this, arguments);
      }

      return watchAsset;
    }()
  }]);

  return InjectedConnector;
}(Connector);

var balanceAction = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref) {
    var _config$formatUnits, _chain$nativeCurrency, _chain$nativeCurrency2, _chain$nativeCurrency3, _chain$nativeCurrency4, _ref$chains, chains, config, provider, unit, contract, _yield$Promise$all, _yield$Promise$all2, _value, decimals, symbol, value, chain;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _ref$chains = _ref.chains, chains = _ref$chains === void 0 ? [].concat(_toConsumableArray(defaultChains), _toConsumableArray(defaultL2Chains)) : _ref$chains, config = _ref.config, provider = _ref.provider;
            unit = (_config$formatUnits = config.formatUnits) !== null && _config$formatUnits !== void 0 ? _config$formatUnits : 'ether';

            if (!config.token) {
              _context9.next = 12;
              break;
            }

            contract = new ethers.Contract(config.token, erc20ABI, provider);
            _context9.next = 6;
            return Promise.all([contract.balanceOf(config.addressOrName), contract.decimals(), contract.symbol()]);

          case 6:
            _yield$Promise$all = _context9.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            _value = _yield$Promise$all2[0];
            decimals = _yield$Promise$all2[1];
            symbol = _yield$Promise$all2[2];
            return _context9.abrupt("return", {
              decimals: decimals,
              formatted: utils.formatUnits(_value, unit),
              symbol: symbol,
              unit: unit,
              value: _value
            });

          case 12:
            _context9.next = 14;
            return provider.getBalance(config.addressOrName);

          case 14:
            value = _context9.sent;
            chain = chains.find(function (x) {
              return x.id === provider.network.chainId;
            });
            return _context9.abrupt("return", {
              decimals: (_chain$nativeCurrency = chain === null || chain === void 0 ? void 0 : (_chain$nativeCurrency2 = chain.nativeCurrency) === null || _chain$nativeCurrency2 === void 0 ? void 0 : _chain$nativeCurrency2.decimals) !== null && _chain$nativeCurrency !== void 0 ? _chain$nativeCurrency : 18,
              formatted: utils.formatUnits(value, unit),
              symbol: (_chain$nativeCurrency3 = chain === null || chain === void 0 ? void 0 : (_chain$nativeCurrency4 = chain.nativeCurrency) === null || _chain$nativeCurrency4 === void 0 ? void 0 : _chain$nativeCurrency4.symbol) !== null && _chain$nativeCurrency3 !== void 0 ? _chain$nativeCurrency3 : 'ETH',
              unit: unit,
              value: value
            });

          case 17:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function balanceAction(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

export { InjectedConnector, balanceAction, erc1155ABI, erc20ABI, erc721ABI, units };